import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import IconPlus from 'components/icons/iconPlus';
import Currency from 'components/consumer/Currency';
import Placeholder from 'components/consumer/Placeholder';
import ProtectionPlanButtonAndModal from 'components/consumer/ProtectionPlanButtonAndModal';
import ProtectionPlanModal from 'components/consumer/ProtectionPlanModal';
import PDPProtectionPlanSelectorPlaceholder from './PDPProtectionPlanSelectorPlaceholder';
import usePdpSelectedProtectionPlanId from '../state/pdpSelectedProtectionPlanId/usePdpSelectedProtectionPlanId';
import useResetPdpSelectedProtectionPlanId from '../state/pdpSelectedProtectionPlanId/useResetPdpSelectedProtectionPlanId';
const PDPProtectionPlanSelectorUI = t0 => {
  const $ = _c(34);
  const {
    allProtectionPlanTypes,
    loading,
    meta,
    onProtectionPlanSelection,
    isLayoutRevamp: t1
  } = t0;
  const isLayoutRevamp = t1 === undefined ? false : t1;
  const [isProtectionModalOpen, setIsProtectionModalOpen] = useState(false);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsProtectionModalOpen(true);
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const openProtectionModal = t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setIsProtectionModalOpen(false);
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const closeProtectionModal = t3;
  const pdpSelectedProtectionPlanId = usePdpSelectedProtectionPlanId();
  const resetPdpSelectedProtectionPlanId = useResetPdpSelectedProtectionPlanId();
  const revampRowRef = useRef(null);
  if (loading && isLayoutRevamp) {
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <PDPProtectionPlanSelectorPlaceholder isLayoutRevamp={true} />;
      $[2] = t4;
    } else {
      t4 = $[2];
    }
    return t4;
  }
  if (loading) {
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <div className="min-h-[66px] mt-8 mx-0 mb-0 w-full"><Placeholder type="rect" loading={true} style={{
          height: "52px"
        }} /></div>;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    return t4;
  }
  let t4;
  if ($[4] !== allProtectionPlanTypes || $[5] !== pdpSelectedProtectionPlanId) {
    t4 = pdpSelectedProtectionPlanId ? allProtectionPlanTypes.filter(singlePlan => singlePlan.plan_id === pdpSelectedProtectionPlanId)?.[0] : null;
    $[4] = allProtectionPlanTypes;
    $[5] = pdpSelectedProtectionPlanId;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const selectedProtectionPlan = t4;
  let t5;
  if ($[7] !== allProtectionPlanTypes || $[8] !== meta?.eligible_protection_planids) {
    t5 = allProtectionPlanTypes ? allProtectionPlanTypes.filter(singlePlan_0 => meta?.eligible_protection_planids.includes(singlePlan_0.plan_id)) : [];
    $[7] = allProtectionPlanTypes;
    $[8] = meta?.eligible_protection_planids;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const eligible_plans = t5;
  let t6;
  if ($[10] !== eligible_plans || $[11] !== isProtectionModalOpen || $[12] !== onProtectionPlanSelection || $[13] !== resetPdpSelectedProtectionPlanId || $[14] !== selectedProtectionPlan) {
    t6 = <ProtectionPlanButtonAndModal close={closeProtectionModal} eligible_plans={eligible_plans} forPage="PDP" isOpen={isProtectionModalOpen} onSelect={onProtectionPlanSelection} openModal={openProtectionModal} removeProtectionPlan={resetPdpSelectedProtectionPlanId} selectedProtectionPlan={selectedProtectionPlan} />;
    $[10] = eligible_plans;
    $[11] = isProtectionModalOpen;
    $[12] = onProtectionPlanSelection;
    $[13] = resetPdpSelectedProtectionPlanId;
    $[14] = selectedProtectionPlan;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const protectionPlanButtonAndModal = t6;
  if (isLayoutRevamp) {
    let t7;
    if ($[16] !== eligible_plans || $[17] !== isProtectionModalOpen || $[18] !== onProtectionPlanSelection || $[19] !== selectedProtectionPlan) {
      t7 = <ProtectionPlanModal buttonRef={revampRowRef} close={closeProtectionModal} eligiblePlans={eligible_plans} forPage="PDP" isOpen={isProtectionModalOpen} onSelect={onProtectionPlanSelection} selectedPlan={selectedProtectionPlan} />;
      $[16] = eligible_plans;
      $[17] = isProtectionModalOpen;
      $[18] = onProtectionPlanSelection;
      $[19] = selectedProtectionPlan;
      $[20] = t7;
    } else {
      t7 = $[20];
    }
    const t8 = selectedProtectionPlan ? undefined : "dialog";
    const t9 = selectedProtectionPlan ? `Remove ${selectedProtectionPlan.plan_name}` : undefined;
    const t10 = selectedProtectionPlan ? resetPdpSelectedProtectionPlanId : openProtectionModal;
    let t11;
    if ($[21] !== selectedProtectionPlan) {
      t11 = selectedProtectionPlan ? <><span className="min-w-0 break-words">5-year {selectedProtectionPlan.plan_name} (+<Currency>{selectedProtectionPlan.plan_price}</Currency>)</span><span className="flex-none text-xs text-brand hover:underline">Remove</span></> : <>Add Protection<IconPlus aria-hidden="true" height="12" width="12" /></>;
      $[21] = selectedProtectionPlan;
      $[22] = t11;
    } else {
      t11 = $[22];
    }
    let t12;
    if ($[23] !== t10 || $[24] !== t11 || $[25] !== t8 || $[26] !== t9) {
      t12 = <button ref={revampRowRef} type="button" aria-haspopup={t8} aria-label={t9} className="flex items-center justify-between gap-2 w-full min-h-[3rem] p-3 bg-transparent border-0 cursor-pointer text-left text-base font-bold text-gray focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-brand focus-visible:-outline-offset-2" onClick={t10}>{t11}</button>;
      $[23] = t10;
      $[24] = t11;
      $[25] = t8;
      $[26] = t9;
      $[27] = t12;
    } else {
      t12 = $[27];
    }
    let t13;
    if ($[28] !== t12 || $[29] !== t7) {
      t13 = <div className="mt-8 w-full rounded border border-solid border-gray-light6 hover:border-gray-light2" data-xc="PDPProtectionPlanRow">{t7}{t12}</div>;
      $[28] = t12;
      $[29] = t7;
      $[30] = t13;
    } else {
      t13 = $[30];
    }
    return t13;
  }
  let t7;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <h3 className="text-base font-bold mt-0 mx-0 mb-1.5">Protect Your Investment</h3>;
    $[31] = t7;
  } else {
    t7 = $[31];
  }
  let t8;
  if ($[32] !== protectionPlanButtonAndModal) {
    t8 = <div className="min-h-[66px] mt-8 mx-0 mb-0 w-full">{t7}{protectionPlanButtonAndModal}</div>;
    $[32] = protectionPlanButtonAndModal;
    $[33] = t8;
  } else {
    t8 = $[33];
  }
  return t8;
};
PDPProtectionPlanSelectorUI.propTypes = {
  allProtectionPlanTypes: PropTypes.array,
  loading: PropTypes.bool,
  meta: PropTypes.object,
  onProtectionPlanSelection: PropTypes.func,
  isLayoutRevamp: PropTypes.bool
};
export default PDPProtectionPlanSelectorUI;